import { call, CallEffect, put, PutEffect } from 'redux-saga/effects';
import { postDeupaiData } from '../shared/fetchApi';
import { Chat, Message, sendMessage, retryMessage, sendMessageFailure, sendMessageSuccess } from '../store/Chatbot.store';

// Function to process the message
function* processMessage(message: string, messages: Message[], sessionId: string): Generator<CallEffect<Message>, Message, Message> {
    try {
        const chat: Chat = {
            mostRecentMessage: message,
            chatHistory: messages,
            sessionId: sessionId,
        };

        return yield call(postDeupaiData, chat);
    } catch (error) {
        console.error('Error in processMessage:', error);
        throw new Error('Failed to send message');
    }
}

export function* chatbotSaga(
    action: ReturnType<typeof sendMessage> | ReturnType<typeof retryMessage>
): Generator<
    CallEffect<Message> | PutEffect<ReturnType<typeof sendMessageSuccess> | ReturnType<typeof sendMessageFailure>>,
    void,
    Message
> {
    try {
        console.log('Handling action:', action.payload);

        const { message, messages, sessionId } = action.payload;

        const reply: Message = yield call(processMessage, message, messages, sessionId);

        console.log('Message processed successfully, reply:', reply);

        yield put(sendMessageSuccess(reply));
    } catch (error) {
        console.error('Error while processing message:', error);
        yield put(sendMessageFailure());
    }
}
